const config = require('../config')
config.name = 'internal-app'
module.exports = config



// WEBPACK FOOTER //
// ./src/internal-app/config.js